module.exports = __webpack_public_path__ + "media/src/images/icons/store-e88975e463db813ab80fa05be521b2f1.svg";